/* @jsx h */
import { h } from "preact";
import Checkbox from "@ingka/checkbox";
import { useChecklistContext } from "../../context";
import Hyperlink from "@ingka/hyperlink";
import PropTypes from "prop-types";
import variables from "/src/scss/variables.module.scss";
import "./list-item.scss";
import { sendGAItemLinkClick, sendGAItemCheck, sendGAItemUncheck } from "../../helpers";
/*
 * SublistId and item.id are both required props 
 * as these values comprise the list item's unique id
 * in storage.
 */
function ListItem({ item = {}, checked = false, sublistId = "" }) {
    const { onItemCheck } = useChecklistContext();
    const { id, label, url, urlText } = item;
    const { prefix: stylePrefix } = variables;

    const onCheck = () => {
        if (!checked) sendGAItemCheck();
        else sendGAItemUncheck();
        onItemCheck(sublistId, id);
    };

    return (
        <div className="list-item">
            <Checkbox prefix={stylePrefix} checked={checked} onChange={onCheck} label={label} id={id} />
            {url && !checked && (
                <Hyperlink prefix={stylePrefix} text={urlText || `Shop Online`} url={url} colour={"grey"} newWindow={true} onClick={sendGAItemLinkClick}/>
            )}
        </div>
    );
}

ListItem.propTypes = {
    item: PropTypes.object,
    checked: PropTypes.bool,
    sublistId: PropTypes.string
};

export default ListItem;
